module.exports = __webpack_public_path__ + "media/images/category/dummy/accessory06-91932563ee24daaebc639625e80cfefc.jpg";